import { IGridWallRequest } from '@api/models';
import { Card, CircularProgress, useDialog } from '@hyperflake/react-ui-library';
import { Img } from 'modules/shared/features/content';
import SneakPeekModal from '../SneakPeekModal/SneakPeekModal';
import OverflowTooltip from '@components/OverflowTooltip/OverflowTooltip';
import moment from 'moment';
import { Avatar } from '@library/avatar';

interface IGridwallRequestDetail {
    isLoading: boolean;
    gridwall: IGridWallRequest;
}

const GridwallRequestDetail = (props: IGridwallRequestDetail) => {
    const { isLoading, gridwall } = props;

    const gridwallSneakPeekModal = useDialog<string>('');

    if (isLoading)
        return (
            <div className="mt-6 flex justify-center items-center min-h-[600px]">
                <CircularProgress />
            </div>
        );

    return (
        <>
            <Card className="mt-4">
                <Card.Header>
                    <h6>Basic Detail</h6>
                </Card.Header>
                <Card.Body>
                    <div className="grid grid-cols-12 gap-6">
                        <div className="col-span-12 sm:col-span-6 lg:col-span-3">
                            <div className="text-grayscale-500 text-sm mb-[6px]">GridWall Name</div>
                            <h6>{gridwall.name}</h6>
                        </div>
                        <div className="col-span-12 sm:col-span-6 lg:col-span-3">
                            <div className="text-grayscale-500 text-sm mb-[6px]">Created by</div>
                            <div className="flex gap-2">
                                <div>
                                    <Avatar src={gridwall.user.dpUrl} alt={gridwall.user.name} size={24} />
                                </div>

                                <h6 className="overflow-hidden">
                                    <OverflowTooltip>{gridwall.user.name}</OverflowTooltip>
                                </h6>
                            </div>
                        </div>
                        <div className="col-span-12 sm:col-span-6 lg:col-span-3">
                            <div className="text-grayscale-500 text-sm mb-[6px]">Created On</div>
                            <h6>
                                <OverflowTooltip>
                                    <div className="whitespace-nowrap">
                                        {moment(gridwall.createdAt, 'YYYYMMDDHHmmss').format('HH:mm A - DD MMM YYYY')}
                                    </div>
                                </OverflowTooltip>
                            </h6>
                        </div>
                        <div className="col-span-12">
                            <div className="text-grayscale-500 text-sm mb-[6px]">Remarks</div>
                            <div className="text-sm font-medium">{gridwall.remarks}</div>
                        </div>
                    </div>
                </Card.Body>
            </Card>
            <Card className="mt-4">
                <Card.Header>
                    <h6>Images</h6>
                </Card.Header>
                <Card.Body>
                    <div className="grid grid-cols-4 gap-4">
                        {gridwall.files.map((file) => (
                            <div
                                key={file._id}
                                className="col-span-1  rounded-md "
                                onClick={() => gridwallSneakPeekModal.show(file.url)}
                            >
                                <Img
                                    src={file.url}
                                    className="w-full h-full aspect-square object-cover object-center"
                                />
                            </div>
                        ))}
                    </div>
                </Card.Body>
            </Card>

            <SneakPeekModal
                onClose={gridwallSneakPeekModal.hide}
                show={gridwallSneakPeekModal.isOpen}
                url={gridwallSneakPeekModal.data}
            />
        </>
    );
};

export default GridwallRequestDetail;
